<template>
  <div class="backPic">
    <b-col class="row ml-10 flex mt-5 inputResp">
      <div>
        <h5 class="border_bottom">Rechercher</h5>
      </div>
      <b-form-radio-group v-model="$parent.selected" size="sm" class="Dflex">
        <!-- Numéro échantillon -->
        <b-col>
          <b-input-group class="mb-2" v-if="from == 'Resultats'">
            <b-form-radio
              class="align-items-center"
              value="echantillon"
              :disabled="$parent.disableRadio"
            >
              <span class="mt-1">Echantillon N° &nbsp; </span>
            </b-form-radio>
            <b-form-input
              :disabled="$parent.echantillonDisable || $parent.disableRadio"
              v-model="$parent.echantillonFilter"
              size="sm"
              @keyup.enter="$parent.getResultsForRangeDates"
            />
            <b-input-group-append>
              <b-button
                :disabled="!$parent.echantillonFilter"
                @click="$parent.echantillonFilter = ''"
                size="sm"
              >
                <i class="fa fa-times"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-input-group class="mb-2" v-if="from == 'Demandes'">
            <b-form-checkbox
              v-model="$parent.select"
              @change="$parent.getResultsForRangeDates"
            >
              <span class="mt-1">Lister les demandes déjà traitées</span>
            </b-form-checkbox>
          </b-input-group>
        </b-col>
        <!-- Date début et date fin -->
        <b-col>
          <b-input-group class="mb-2">
            <div class="d-flex flex-column align-items-end">
              <div class="d-flex align-items-center mb-2">
                <b-form-radio
                  class="align-items-center mb-2"
                  aria-selected="selected"
                  value="dateDbtFin"
                  :disabled="$parent.disableRadio"
                >
                  <div style="width: 2em">Du &nbsp;</div>
                </b-form-radio>
                <b-form-input
                  :disabled="$parent.dateDisable || $parent.disableRadio"
                  v-model="$parent.dateDebut"
                  type="date"
                  size="sm"
                  id="targetDates"
                  style="width: 12em"
                  @keyup.enter="$parent.getResultsForRangeDates"
                />
              </div>
              <div>
                <b-input-group class="align-items-center">
                  <div style="width: 2em">Au &nbsp;</div>
                  <b-form-input
                    :disabled="$parent.dateDisable || $parent.disableRadio"
                    v-model="$parent.dateFin"
                    :max="$parent.dateMax"
                    type="date"
                    size="sm"
                    style="width: 12em"
                    @keyup.enter="$parent.getResultsForRangeDates"
                  />
                </b-input-group>
              </div>
            </div>
          </b-input-group>
        </b-col>
      </b-form-radio-group>

      <!-- SAC-only customer select -->
      <div v-if="isSac" class="mb-2" style="width: 18rem; margin-right: 1rem">
        <b-form-select
          :options="sacCustomers"
          v-model="selectedSacCustomer"
          @change="onSacCustomerChange"
          size="sm"
          :disabled="!sacCustomers || sacCustomers.length === 0"
          class="mr-2"
          aria-label="Sélection client SAC"
          :text-field="'label'"
          :value-field="'value'"
        >
          <template #first>
            <option :value="null">-- Tous les clients --</option>
          </template>
        </b-form-select>
      </div>

      <b-button
        class="btn btn-resultats rad btn btn-secondary btn-secondary mb-3"
        size="sm"
        @click="$parent.getResultsForRangeDates"
        :disabled="$parent.disableRadio"
        >Rechercher</b-button
      >
    </b-col>

    <b-col>
      <b-form-radio-group
        v-if="from === 'Resultats'"
        buttons
        v-model="$parent.tri"
        size="sm"
        class="mb-3"
      >
        <b-form-radio
          value="resultatsRadio"
          class="text-left btn-resultats rad mr-2"
          :class="{
            'font-weight-bold': $parent.tri === 'resultatsRadio' ? true : false,
          }"
          @change="$parent.displayByResults"
        >
          <span>Résultats</span>
        </b-form-radio>
        <b-form-radio
          value="echantillonsRadio"
          class="text-left btn-resultats rad mr-2"
          :class="{
            'font-weight-bold':
              $parent.tri === 'echantillonsRadio' ? true : false,
          }"
          @change="$parent.displayByEchantillon"
        >
          <span>Echantillons</span>
        </b-form-radio>
        <b-form-radio
          value="analyseRadio"
          class="text-left btn-resultats rad mr-2"
          :class="{
            'font-weight-bold': $parent.tri === 'analyseRadio' ? true : false,
          }"
          @change="$parent.displayByAnalyse"
        >
          <span>Analyses</span>
        </b-form-radio>
        <b-form-radio
          value="productRadio"
          class="text-left btn-resultats rad mr-2"
          :class="{
            'font-weight-bold': $parent.tri === 'productRadio' ? true : false,
          }"
          @change="$parent.displayByProduct"
        >
          <span>Produits</span>
        </b-form-radio>
        <b-form-radio
          v-if="$root.user.right['Labco-s']['/synthese-analyses']"
          value="syntheseRadio"
          class="text-left btn-resultats rad mr-2"
          :class="{
            'font-weight-bold': $parent.tri === 'synthese' ? true : false,
          }"
          @change="$parent.displaySynthese"
        >
          <span>Synthèse</span>
        </b-form-radio>
      </b-form-radio-group>

      <b-dropdown text="Documents" v-if="from === 'Demandes'" right class="float-right ml-3 mr-3 mb-3">
        <b-dropdown-item
          href="http://www.aclccp.com/doc/230115_BAC.pdf"
          target="_blank"
          >Réaliser un prélèvement</b-dropdown-item
        >
        <b-dropdown-item
          href="http://www.aclccp.com/doc/230115_TRANS.pdf"
          target="_blank"
          >Transport des prélèvements</b-dropdown-item
        >
      </b-dropdown>

      <b-button
        v-if="from === 'Demandes'"
        @click="$parent.runExport"
        class="float-right mb-3 btn-resultats rad btn btn-secondary"
      >
        Exporter les analyses
      </b-button>
      <b-button
        v-if="
          from === 'Resultats' &&
          $parent.tri != 'analyseRadio' &&
          $parent.tri != 'productRadio' &&
          !this.$parent.radioSynthese
        "
        @click="$parent.runExport"
        class="float-right mb-3 btn-resultats rad btn btn-secondary"
      >
        Exporter les résultats
      </b-button>
      <b-button
        v-if="from === 'Demandes'"
        @click="$parent.showModal('create')"
        class="button_ajout_style float-right mr-3 mb-3"
      >
        Ajout Echantillon
      </b-button>
    </b-col>
  </div>
</template>

<script>
import api from '../api'

// import moment from 'moment'

export default {
  name: 'HeaderSearch',
  components: {},
  props: [
    'from'
  ],
  data () {
    return {
      isSac: false,
      sacCustomers: [],
      selectedSacCustomer: null
    }
  },
  methods: {
    getSacCustomers () {
      api.getAllSacCustomers().then(response => {
        // Response shape may be either { data: [...] } or { customers: [...] } or { data: { customers: [...] } }
        let customers = []
        if (response) {
          if (Array.isArray(response.data)) {
            customers = response.data
          } else if (Array.isArray(response.customers)) {
            customers = response.customers
          } else if (response.data && Array.isArray(response.data.customers)) {
            customers = response.data.customers
          }
        }
        // Normalize to objects with value/label for the select
        this.sacCustomers = customers.map(c => {
          return {
            value: c.CLT_NUM || c.CENT_CLT || c.CLT_NUMERO || c.CENT_NUM || null,
            label: c.CLT_RSO || c.CENT_LIB || c.name || (c.CLT_NUM || c.CENT_CLT || '')
          }
        })
      }).catch(error => {
        console.error('Error fetching SAC customers:', error)
        this.sacCustomers = []
      })
    },
    onSacCustomerChange (value) {
      // Emit the selected SAC customer value (nullable) to parent for local filtering
      this.$emit('sac-customer-selected', value)
    }
  },
  mounted () {
    this.isSac = (this.$root.user.login === 907 || this.$root.user.login === 9999)
    if (this.isSac) {
      this.getSacCustomers()
    }
  }
}
</script>


<style>
h5 {
  color: #24509e;
}

.border_bottom {
  border-bottom: #24509e 1px solid;
}

.button_style {
  background-color: #89c338 !important;
  border-color: #2083bc !important;
}

.button_style:hover {
  background-color: #ffffff !important;
  border-color: #89c338 !important;
  color: #2083bc !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
  background-color: #89c338 !important;
}

.margin_2_rem {
  margin-left: 2rem;
}

.custom-control-inline {
  margin-right: 0;
}

.spinner_div {
  position: fixed;
  top: 50vh;
  left: 50vw;
  z-index: 15;
}

.spinner_lg_size {
  width: 3rem;
  height: 3rem;
}

.color_green_labco {
  color: #89c338;
}

.btn-light:not(:disabled):not(.disabled).active,
.btn-light:not(:disabled):not(.disabled):hover {
  /* color: black !important; */
  background-color: transparent;
  border-color: transparent;
}

.flex {
  display: flex;
  justify-content: center;
}

.btn-resultats {
  background: #509eb3;
  height: 50%;
}

.btn-resultats:active {
  background: #24509e !important;
}

.btn-resultats:hover {
  background: #24509e !important;
}

.rad {
  border-radius: 0px 20px 0px 20px !important;
}

.btn-secondary:not(:disabled):not(.disabled).active,
.btn-secondary:not(:disabled):not(.disabled):active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #24509e !important;
  border-color: transparent !important;
}

.backPic {
  background-image: url(../assets/bandeauTabl.jpg);

  /* Supression de la marge intérieur de container fluid */
  margin-left: -15px;
  margin-right: -15px;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url("../assets/radioactive.png");
}

.custom-radio .custom-control-label::before {
  background-image: url("../assets/radio.png");
}

.custom-control-label::after {
  background-size: cover !important;
}

.custom-control-label::before {
  background-size: cover !important;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ebf0f2 !important;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #dce7eb !important;
}

.table td {
  font-weight: bold;
}

.modal-body h6 {
  color: #509eb3;
}
.modal-body h5 {
  color: #157884;
}

@media (max-width: 1200px) {
  .backPic {
    background-size: cover;
  }
}

@media (max-width: 1050px) {
  .inputResp {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 640px) {
  .Dflex {
    flex-direction: column;
  }
}

.Dflex {
  display: flex;
}

.dropdown-menu a.dropdown-item:hover {
  background: #0071bc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderSearchComponent.vue